type BusinessBrandPackage = {
    id: string;
    name: string,
    price: number;
}

export const businessBrandPackages: Record<string, BusinessBrandPackage> = {
    'basic': {
        id: 'basic',
        name: 'Basic',
        price: 0,
    },
    'pro': {
        id: 'pro',
        name: 'Pro',
        price: 45,
    },
    'pro+banner': {
        id: 'pro+banner',
        name: 'Pro+Banner',
        price: 95.,
    },
};
